import BreakpointsEnum from "../enums/breakpointsEnum";

$(function () {
    let App = window.App;
    App.menu = {};

    let $body = $('body');

    const makeInactiveMenuItem = function () {
        $('.nav-items > .nav-item.active').removeClass('active');
        $('.nav-items').removeClass('freeze');
        $('.nav-drill').removeClass('freeze');
    }

    $(document).on('click', '.nav-link:not(.nav-back-link)', function (e) {
        let $item = $(this).closest('.nav-expand');

        if (window.App.getBreakpoint() !== BreakpointsEnum.tablet && window.App.getBreakpoint() !== BreakpointsEnum.mobile) {
            makeInactiveMenuItem();
        }

        if (window.App.getBreakpoint() === BreakpointsEnum.tablet || window.App.getBreakpoint() === BreakpointsEnum.mobile) {
            if ($(this).hasClass('nav-expand-link')) {
                e.preventDefault();
            }

            let $prev = $item.closest('.nav-items');
            $item.closest('.nav-drill').addClass('freeze');

            if ($prev) {
                $prev.animate({scrollTop: 0}, 0);
                $prev.addClass('freeze');
            }
        }

        $item.addClass('active');
    });

    $(document).on('click', '[data-menu-action="back"]', function () {
        let $prev = $(this).closest('.nav-items.freeze');

        if ($prev) {
            $prev.removeClass('freeze');

            if ($prev.closest('.nav-items.freeze').length === 0) {
                $(this).closest('.nav-drill').removeClass('freeze');
            }
        }

        $(this).closest('.nav-expand').removeClass('active');
    });

    App.menu.closeOpenMenu = function () {
        $body.removeClass(function (index, className) {
            return (className.match(/(^|\s)open-menu-\S+/g) || []).join(' ');
        });
    }

    $(document).on('click', '[data-menu]', function () {
        $('.nav-items:first-child').animate({scrollTop: 0}, 0);
        $('.nav-items').removeClass('freeze');
        makeInactiveMenuItem();

        let currentMenuClass = `open-menu-${$(this).data('menu')}`;

        if ($body.hasClass(currentMenuClass)) {
            $body.removeClass(currentMenuClass);
        } else {
            App.modal.closeOpenModal();
            App.menu.closeOpenMenu();

            let timer = setTimeout(function () {
                $body.addClass(currentMenuClass);

                if (window.App.getBreakpoint() !== BreakpointsEnum.tablet && window.App.getBreakpoint() !== BreakpointsEnum.mobile) {
                    $('.nav-items:first-child .nav-expand:first').addClass('active');
                }

                clearTimeout(timer);
            }, 200);
        }
    });

    $(document).on('mouseenter', '.menu-catalog > .nav-drill > .nav-items > .nav-expand', function () {
        if (window.App.getBreakpoint() === BreakpointsEnum.desktop || window.App.getBreakpoint() === BreakpointsEnum.largeDesktop) {
            if (!$(this).hasClass('active')) {
                makeInactiveMenuItem();
                $(this).addClass('active');
            }
        }
    });
});